var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKunst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.847,5.6a1.679,1.679,0,0,0,.111-1.317h0c-.067-.194-.141-.368-.212-.535a3.245,3.245,0,0,1-.274-.836l-.017-.157c-.005-.083-.015-.152-.015-.152a.217.217,0,0,0-.414,0s-.01.069-.014.143L11,2.9a3.267,3.267,0,0,1-.275.844c-.072.167-.146.341-.213.535A1.675,1.675,0,0,0,10.62,5.6a.48.48,0,0,0,.265.207.411.411,0,0,0-.082.237v.726a.422.422,0,0,0-.157.325v5.486a.429.429,0,0,0,.43.43h.314a.429.429,0,0,0,.43-.43V7.092a.422.422,0,0,0-.157-.325V6.041a.414.414,0,0,0-.082-.238A.481.481,0,0,0,11.847,5.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.377,8.477A2.392,2.392,0,0,0,8.049,7.343l-.108-.038a.762.762,0,0,1-.509-.725.749.749,0,0,1,.28-.57,1.313,1.313,0,0,0,.459-1.384,1.326,1.326,0,0,0-1.446-.947,4.6,4.6,0,0,0,0,9.2l.12,0A3.013,3.013,0,0,0,9.377,8.477ZM3.04,8.11a.465.465,0,1,1,.465.465A.465.465,0,0,1,3.04,8.11Zm.994,2.357A.465.465,0,1,1,4.5,10,.465.465,0,0,1,4.034,10.467Zm.328-3.839a.465.465,0,1,1,.465-.465A.465.465,0,0,1,4.362,6.628Zm1.322,5.025a.465.465,0,1,1,.465-.465A.465.465,0,0,1,5.684,11.653ZM6.793,8.986A.61.61,0,1,1,7.4,8.377.61.61,0,0,1,6.793,8.986ZM7.6,11.441a.465.465,0,1,1,.464-.464A.465.465,0,0,1,7.6,11.441Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKunst);
export default __webpack_public_path__ + "static/media/KUNST.d43c10574facaf004ff83de517601993.svg";
export { ForwardRef as ReactComponent };